export const tableHeaderAsmVul = (t) => [
  {
    id: 'title',
    type: 'text',
    value: t('asm:tabVulnerability.table.title'),
  },
  {
    id: 'host',
    type: 'text',
    value: t('asm:tabVulnerability.table.host'),
  },
  {
    id: 'description',
    type: 'text',
    value: t('asm:tabVulnerability.table.description'),
  },
  {
    id: 'severity',
    type: 'text',
    value: t('asm:tabVulnerability.table.severity'),
  },
  {
    id: 'status',
    type: 'text',
    value: t('asm:tabVulnerability.table.status'),
  },
];
